import { ITableField } from '../index'
import { MouseEvent } from 'react'
import Checkbox from '../../../Inputs/Checkbox'

interface IProps<T extends Record<string, any>, K extends keyof T> {
  fields: ITableField<T, K>[]

  selected: Set<K>
  handleSelect: (key: K, selected: boolean) => void

  onCLick?: (item: T, ev?: MouseEvent<HTMLTableCellElement>) => void
  item: T
  itemKey: K
  renderItemContextMenu?: (item: T) => JSX.Element
  index: number
}

const TableRow = <T extends Record<string, any>, K extends keyof T>(props: IProps<T, K>) => {
  const onClick = props.onCLick ? (ev: MouseEvent<HTMLTableCellElement>) => props.onCLick(props.item, ev) : undefined

  const renderField = (field: ITableField<T, K>) => {
    const value = field.getter(props.item, field.key)

    let title = ''
    if (typeof value === 'string') title = value

    return (
      <td key={field.key as string} onClick={onClick} title={title}>
        <div className={typeof value === 'string' ? 'line-clamp' : undefined}>{value}</div>
      </td>
    )
  }

  return (
    <>
      {props.handleSelect && (
        <td className="table--checkbox-col">
          <Checkbox
            checked={props.selected?.has(props.item[props.itemKey])}
            onCheck={(checked) => props.handleSelect(props.item[props.itemKey], checked)}
          />
        </td>
      )}
      {props.fields.map(renderField)}
    </>
  )
}

export default TableRow
